import { useMutation } from '@tanstack/react-query';
import { authMutations } from './auth-mutations';
import type { MutationResult } from 'app/queries/types';

export const useClearSessionMutation = (): MutationResult<void> => {
  const { mutate, mutateAsync, isPending, error } = useMutation(authMutations.clearSession());
  return { mutate, mutateAsync, isPending, error };
};
